<a
  title="Rentag"
  class="flex items-end justify-between"
  href="https://rentag.ru"
  target="_blank"
  referrerpolicy="no-referrer"
  [ngClass]="{ 'lg:py-4': !removePaddings }"
>
  @switch (isDemo) {
    @case (true) {
      <div class="mr-3 w-[50px] h-[37px]">
        <img class="w-full h-full" src="/assets/img/branding/logo.svg" alt="Logo" />
      </div>
    }
    @case (false) {
      <div class="mr-3 w-[173px] h-[44px]">
        <img class="w-full h-full" src="/assets/img/branding/logo_full_new.svg" alt="Logo" />
      </div>
    }
  }
</a>
